export default __webpack_public_path__ + "static/media/locationW.b735e1fe.svg";